import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  update(event) {
    // Force re-render of peer-checked styles by triggering a small DOM update
    // This ensures Tailwind's peer-checked classes apply correctly
    const container = this.element
    container.querySelectorAll('input[type="radio"]').forEach(radio => {
      const span = radio.nextElementSibling
      if (span) {
        if (radio.checked) {
          span.classList.add('bg-pink-100', 'text-pink-700', 'border-pink-300')
          span.classList.remove('bg-white', 'text-gray-600', 'border-gray-200')
        } else {
          span.classList.remove('bg-pink-100', 'text-pink-700', 'border-pink-300')
          span.classList.add('bg-white', 'text-gray-600', 'border-gray-200')
        }
      }
    })
  }
}
